<script>
export default {
    name: 'UsaFlagIcon',
};
</script>
<template>
    <path
        d="M0.79 0.001l1.208 0c0.018,0 0.033,0.015 0.033,0.033l0 1.31c0,0.018 -0.015,0.033 -0.033,0.033l-1.965 0c-0.018,0 -0.033,-0.015 -0.033,-0.033l0 -0.749 0 -0.561 0 -0.001c0,-0.018 0.015,-0.033 0.033,-0.033l0.748 0c0.003,0 0.006,0 0.009,0.001zm0.024 0.066l0 0.121 1.151 0 0 -0.121 -1.151 0zm0 0.187l0 0.121 1.151 0 0 -0.121 -1.151 0zm0 0.187l0 0.122 1.151 0 0 -0.122 -1.151 0zm-0.748 0.678l1.899 0 0 -0.117 -1.899 0 0 0.117zm1.899 0.065l-1.899 0 0 0.127 1.899 0 0 -0.127zm-1.899 -0.247l1.899 0 0 -0.122 -1.899 0 0 0.122zm0 -0.187l1.899 0 0 -0.122 -1.899 0 0 0.122z"
    />
</template>
